import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValues = {
  description: '',
  code: '',
  type: '',
  codeAnpr: '',
  use: '',
  dateFrom: null,
  dateTo: null,
  page: 0,
  rowsPerPage: 10,
  orders: {},
};

const ReleaseModeInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

ReleaseModeInitializer.displayName = 'Page release mode List initializer component';

export default ReleaseModeInitializer;
